<app-loading *ngIf="isLoading"></app-loading>

<mat-form-field *ngIf="!isLoading" [ngClass]="{ left: typeCall, 'disabled-datepicker': disabled }">
  <mat-label>{{typeCall}}</mat-label>
  <input
    matInput
    [id]="id"
    [min]="minDate"
    [max]="maxDate"
    (dateChange)="addEvent($event)"
    [matDatepicker]="picker1"
    class="col-9 calendar-input"
    [formControl]="date"
    readonly
    autocomplete="off"
    (click)="picker1.open()"
  />

  <mat-hint>
    <mat-error *ngIf="!availableDates.length">{{ dateError }}</mat-error>
  </mat-hint>

  <mat-datepicker-toggle
    [id]="id + '-toggle'"
    matSuffix
    [for]="picker1"
  ></mat-datepicker-toggle>

  <mat-datepicker
    [id]="id + '-calendar'"
    #picker1
    [disabled]="disabled"
    (opened)="loadDatesAvailables()"
    [dateClass]="dateClass"
  ></mat-datepicker>
</mat-form-field>
